// Figma node: 354:360
// 참고: src/components/AIR_COMPONENT.md
import React from "react";

interface BubbleSuggestionProps {
  content: string;
}

const BubbleSuggestion = ({ content }: BubbleSuggestionProps) => {
  return (
    <div
      className="border border-[#eeeeee] border-solid box-border flex font-['Pretendard:Medium',sans-serif] gap-1 items-start justify-end leading-none w-full max-w-full not-italic px-3 py-2 rounded-bl-[20px] rounded-br-[20px] rounded-tl-[20px]"
      data-node-id="354:360"
    >
      <div
        className="flex flex-col justify-center text-[#c5abfa] text-base md:text-lg tracking-tight whitespace-nowrap"
        data-node-id="354:358"
      >
        <p className="leading-4 md:leading-5">Q</p>
      </div>
      <div
        className="flex max-w-[100%] flex-col justify-center min-h-px min-w-px text-[#212121] text-sm md:text-base text-right tracking-tight"
        data-node-id="354:359"
      >
        <p className="text-[12px] md:text-[14px] leading-4 md:leading-5 break-words whitespace-pre-line">
          {content}
        </p>
      </div>
    </div>
  );
};

export default BubbleSuggestion;
